export default "__VITE_ASSET__5f46a0cb__"